import React from 'react'

import test from './docs/test';
import test2 from './docs/test2';
import test3 from './docs/test3';


import five_benefits_of_pat_files from './docs/five-benefits-of-pat-files'
import what_is_a_pat_file from './docs/what-is-a-pat-file'
import pat_file_syntax_and_rules from './docs/pat-file-syntax-and-rules'
import pat_from_scratch_intro_tutorial from './docs/pat-from-scratch-intro-tutorial'

import qa_how_to_create_that_pattern_in_revit from './docs/qa-how-to-create-that-pattern-in-revit'
import qa_rotating_direction_of_filled_region from './docs/qa-rotating-direction-of-filled-region'
import qa_revit_pat_files_not_recognized from './docs/qa-revit-pat-files-not-recognized'
import qa_no_model_type_patterns_found from './docs/qa-no-model-type-patterns-found'
import qa_staggered_running_bond_hatch_pattern from './docs/qa-staggered-running-bond-hatch-pattern'
import qa_batt_insulation_pattern from './docs/qa-batt-insulation-pattern'

// create a dictionary of all doc objects,
// summarize tags into a list sorted by frequency
// summarize categories into a list sorted alphabetically 

const docList = [
  test,
  test2,  
  test3,

  five_benefits_of_pat_files,
  what_is_a_pat_file,
  pat_file_syntax_and_rules,
  pat_from_scratch_intro_tutorial,

  qa_how_to_create_that_pattern_in_revit,
  qa_rotating_direction_of_filled_region,
  qa_no_model_type_patterns_found,
  qa_revit_pat_files_not_recognized, 
  qa_staggered_running_bond_hatch_pattern,
  qa_batt_insulation_pattern,
]

const categories = [
  {
    name: '.PAT File Basics',
    slug: 'pat-file-basics'
  },
  {
    name: 'Misc',
    slug: 'misc'
  },
  {
    name: 'Other Cat',
    slug: 'other'
  },
  {
    name: 'Forum Q&A',
    slug: 'q-and-a'
  }
]

const docLoader = () => {

  let retval = {
    dictionary: {},
    list: [],
    tags: [],
    categories: categories
  }

  for(var i in docList){
    // load it
    let doc = docList[i];

    for(var c in categories){
      if(categories[c].slug === doc.category){
        doc.category = categories[c];
        break;
      }
    }

    // add to dictionary
    retval.dictionary[docList[i].slug] = doc;
    retval.list.push(doc);

    // add to tags 
    for(var t in doc.tags){
      
      let found = false;
      for(var tt in retval.tags){
        if(retval.tags[tt].name == doc.tags[t]){
          retval.tags[tt].count++;
          found = true;
          break;
        } 
      }

      if(!found){
        retval.tags.push({
          name: doc.tags[t],
          count: 1
        })
      }
    }
  }

  retval.tags.sort((a,b)=>{
    if(a.count > b.count) return -1;
    if(a.count < b.count) return 1;
  })

  retval.list.sort((a,b)=>{
    if(a.category.name > b.category.name) return 1;
    if(a.category.name < b.category.name) return -1;
    // if(a.category.name == b.category.name) return (Math.random() > .5 ? -1 : 1)
  })

  return retval;
}

export default docLoader();


// WEBPACK FOOTER //
// ./src/docLoader.js